if (!customElements.get('featured-collection-load')) {  customElements.define( 'featured-collection-load',
 class FeaturedCollectionPage extends HTMLElement {
      constructor() {
        super();
        this.loadPage = this.querySelector(".loading-page");
        this.handle = this.dataset.handle;
        this.loadinInfo = { page: 2, loading: false,  done: false,size: parseInt(this.dataset.size) || 8  };
        this.init();
      }

      connectedCallback() {
      }

      init() {
        this.loadPage && this.loadPage.addEventListener('click', this.loadMoreProducts.bind(this));
      }
      async loadMoreProducts(){
        const info = this.loadinInfo;
        if (info.loading || info.done) return;
        info.loading = true;
        try {
            const res = await fetch(`/collections/${this.handle}?section_id=main-collection-product-grid&page=${info.page}`);
            const html = await res.text();
            var warp = this.querySelector('.featured-collection__items');
            const parser = new DOMParser(); 
            const doc = parser.parseFromString(html, 'text/html');

            const newProducts = doc.querySelectorAll('.products-list .f-column');
            if (newProducts.length === 0) {
                info.done = true;
                this.loadPage.style.display = 'none';
            } else {
                newProducts.forEach((product) => {
                warp.appendChild(product);
                });
                this.fixQuickviewDuplicate();
                info.page += 1;
                if (newProducts.length < info.size) {
                    info.done = true;
                    this.loadPage.style.display = 'none';
                }
            }

        } catch (err) {
        console.error("加载失败:", err);
            } finally {
        info.loading = false;
            }
        

      }


      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }
    }
  );
}
